import { AppScrollView } from '@/components/base/app.scroll.view';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';
import { LoaderContainer } from '@/components/compose/loader.container';
import { AppModal } from '@/components/compose/app.modal';
import styled from 'styled-components/native';
import { useTermsAndConditions } from '@/apis/server-configs';

export default function TermsAndConditionsModal() {
  const tc = useTermsAndConditions({});
  return (
    <AppModal title={'قوانین و مقررات'}>
      <LoaderContainer apis={[tc]}>
        {tc.data && (
          <AppScrollView>
            <ContentBox>
              <TermsText text={tc.data} />
            </ContentBox>
          </AppScrollView>
        )}
      </LoaderContainer>
    </AppModal>
  );
}

const ContentBox = styled(Box)`
  padding: ${({ theme }) => theme.wp(10)}px;
`;

const TermsText = styled(AppTextView)`
  text-align: right;
`;
